import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const RecoveryControlPanelApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "RecvryCtrlPnl" */ "./RecoveryControlPanelApp");
    return { default: namedExport.RecoveryControlPanelApp };
});

export const RecoveryControlPanel: TeamAppConfig = {
    title: "Recovery Control Panel",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Recovery Control Panel administrates auto recovery actions and takes a deep look into executed actions.",
    team: "OSP",
    publicId: "ExchangeOSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: RecoveryControlPanelApp,
    path: "/RecoveryControlPanel"
};
